<template>
  <div class="flex flex-row bg-white w-full">
    <span class="name w-1/4 border-b">
      <input
        ref="name" v-model="name" v-autowidth="{maxWidth: '250px', minWidth: '20px', comfortZone: 0}"
        @blur="onInputChange"
      />
    </span>
    <el-menu :default-active="activeIndex" class="w-3/4" mode="horizontal">
      <el-menu-item index="1" class="flex items-stretch">
        <Link class="flex-1 px-5" :href="zroute('app.form.edit', [app_id, form_id])">表单设计</Link>
      </el-menu-item>
      <el-menu-item v-if="flowable" index="2" class="flex items-stretch">
        <Link class="flex-1 px-5" :href="zroute('app.form.edit.flow', [app_id, form_id])">流程设定</Link>
      </el-menu-item>
      <el-menu-item index="3" class="flex items-stretch">
        <Link class="flex-1 px-5" :href="zroute('app.form.publish', [app_id, form_id])">表单发布</Link>
      </el-menu-item>
      <el-menu-item index="4" class="flex items-stretch">
        <Link class="flex-1 px-5" :href="zroute('app.form.data', [app_id, form_id])">数据管理</Link>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import VueInputAutowidth from 'vue-input-autowidth'
import zroute from '../ziggy'
import {Link} from '@inertiajs/inertia-vue'
import axios from 'axios'

export default {
  components: {
    Link,
  },
  directives: {
    autowidth: VueInputAutowidth,
  },
  props: {
    flowable: {
      type: Boolean,
      default: false,
    },
    activeIndex: {
      type: String,
      default: '1',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      form_id: zroute().params.form_id,
      name: this.value,
    }
  },
  methods: {
    onInputChange() {
      axios.post(zroute('app.form.rename', {app_id: this.app_id, form_id: this.form_id}), {
        name: this.name,
      }).then(res => {
        console.log(res)
      })

    },
  },
}
</script>
<style lang="scss" scoped>
.name {

  input {
    font-size: 16px;
    margin: 5px 0;
    padding: 0 2px;
    height: 30px;
    color: #1F2D3D;
    border: 0;
    border-bottom: dashed 1px #333;
    background-color: transparent;
  }
}

.el-menu, .el-menu-item {
  height: 42px;
  line-height: 42px;
  padding: 0;
}
</style>
